import React, { useEffect, useState } from 'react';
import { openWhatsApp } from '../utils/whatsapp';
import { MusicToggle } from './MusicToggle';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Cabañas',
    href: '#cabanas'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Galería',
    href: '#galeria'
  }, {
    name: 'Ubicación',
    href: '#ubicacion'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  const handleWhatsApp = () => {
    openWhatsApp();
  };
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'glass-nav py-2 md:py-3' : 'bg-transparent py-3 md:py-5'}`} data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 md:gap-0" data-id="element-209">
          {/* Top row in mobile (Logo + Music + Reservar) */}
          <div className="flex justify-between items-center w-full md:w-auto" data-id="element-210">
            <a href="#inicio" aria-label="Cabañas El Mirador — Inicio" className="flex-shrink-0" data-id="element-211">
              <img src="https://cdn.magicpatterns.com/uploads/fjHJixcvNp1dVNqWGfC9yC/EL_MIRADOR_LOGO.jpg" alt="Cabañas El Mirador" className={`w-auto object-contain rounded-full bg-white/90 transition-all duration-300 ${isScrolled ? 'h-14 md:h-20' : 'h-24 md:h-40 shadow-xl'}`} data-id="element-212" />
            </a>

            <div className="flex items-center gap-2 md:hidden" data-id="element-213">
              <MusicToggle variant={isScrolled ? 'dark' : 'light'} data-id="element-214" />
              <button onClick={handleWhatsApp} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${isScrolled ? 'bg-olive text-white shadow-sm' : 'bg-white/20 backdrop-blur-sm text-white border border-white/50'}`} data-id="element-215">
                Reservar
              </button>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-216">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-olive ${isScrolled ? 'text-charcoal' : 'text-white/90 hover:text-white drop-shadow-md'}`} data-id="element-217">
                {link.name}
              </a>)}
            <button onClick={handleWhatsApp} className={`px-6 py-2.5 rounded-full font-medium transition-all duration-300 ${isScrolled ? 'bg-olive text-white hover:bg-olive-dark shadow-sm' : 'bg-white/20 backdrop-blur-sm text-white border border-white/50 hover:bg-white hover:text-olive-dark'}`} data-id="element-218">
              Reservar
            </button>
            <MusicToggle variant={isScrolled ? 'dark' : 'light'} data-id="element-219" />
          </div>

          {/* Mobile Menu (Scrollable words) */}
          <div className="md:hidden w-full overflow-x-auto hide-scrollbar pb-1" data-id="element-220">
            <div className="flex items-center justify-center gap-4 min-w-max mx-auto px-1" data-id="element-221">
              {navLinks.filter(link => link.name !== 'Inicio').map(link => <a key={link.name} href={link.href} className={`text-xs font-medium whitespace-nowrap transition-colors ${isScrolled ? 'text-charcoal' : 'text-white drop-shadow-md'}`} data-id="element-222">
                    {link.name}
                  </a>)}
            </div>
          </div>
        </div>
      </div>
    </nav>;
}